
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Contacts',
    labelInn: 'TIN',
    labelEmail: 'E-mail',
    labelAddress: 'Address',
    labelPhone: 'Phone',
  },
  ru: {
    title: 'Контакты',
    labelInn: 'ИНН',
    labelEmail: 'E-mail',
    labelAddress: 'Адрес',
    labelPhone: 'Телефон',
  },
  uz: {
    title: 'Kontaktlar',
    labelInn: 'STIR',
    labelEmail: 'E-mail',
    labelAddress: 'Manzil',
    labelPhone: 'Telefon',
  },
  fa: {
    title: 'تماس',
    labelInn: 'شناسه مالیاتی',
    labelEmail: 'ایمیل',
    labelAddress: 'نشانی',
    labelPhone: 'تلفن',
  },
  pt: {
    title: 'Contatos',
    labelInn: 'ID fiscal',
    labelEmail: 'E-mail',
    labelAddress: 'Endereço',
    labelPhone: 'Telefone',
  },
  tr: {
    title: 'İletişim',
    labelInn: 'Vergi no',
    labelEmail: 'E-posta',
    labelAddress: 'Adres',
    labelPhone: 'Telefon',
  },
});
